import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=70b5e614&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationView.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationView.vue?vue&type=style&index=0&id=70b5e614&prod&lang=scss&"
import style1 from "./ApplicationView.vue?vue&type=style&index=1&id=70b5e614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5e614",
  null
  
)

export default component.exports